<template>
  <section class="hud-card">
    <div class="hud-card__frame hud-card__frame--back"></div>
    <div class="hud-card__frame hud-card__frame--mid"></div>
    <div class="hud-card__frame hud-card__frame--front"></div>
    <div class="hud-card__scan"></div>
    <div class="hud-card__body">
      <slot name="meta" />
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AiHudCard',
});
</script>

<style scoped>
.hud-card {
  position: relative;
  width: 100%;
  max-width: 1180px;
  padding: 52px 48px 42px;
  border-radius: 42px;
  background: transparent;
  border: 0;
  box-shadow: none;
  animation: cardReveal 1.2s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.hud-card::before,
.hud-card::after {
  content: '';
  position: absolute;
  inset: 14px;
  border-radius: 32px;
  pointer-events: none;
}

.hud-card::before {
  display: none;
}

.hud-card::after {
  display: none;
}

.hud-card__body {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hud-card__frame {
  position: absolute;
  inset: 0;
  border-radius: 42px;
  pointer-events: none;
}

.hud-card__frame::before,
.hud-card__frame::after {
  content: '';
  position: absolute;
  border-radius: 18px;
  border: 2px solid rgba(222, 240, 255, 0.88);
  filter: drop-shadow(0 0 14px rgba(125, 190, 255, 0.34));
}

.hud-card__frame--back {
  inset: 24px -28px -28px 24px;
  border-radius: 40px;
  opacity: 0;
}

.hud-card__frame--back::before {
  top: -18px;
  left: 38px;
  width: 110px;
  height: 22px;
  clip-path: polygon(0 100%, 14% 0, 100% 0, 100% 100%);
}

.hud-card__frame--back::after {
  top: -18px;
  right: 38px;
  width: 110px;
  height: 22px;
  clip-path: polygon(0 100%, 0 0, 86% 0, 100% 100%);
}

.hud-card__frame--mid {
  inset: 12px -14px -14px 12px;
  border-radius: 40px;
  opacity: 0;
}

.hud-card__frame--front {
  inset: -16px 28px auto 28px;
  display: none;
}

.hud-card__frame--front::before {
  left: 0;
  width: 82px;
  height: 18px;
  clip-path: polygon(0 100%, 18% 0, 100% 0, 100% 100%);
}

.hud-card__frame--front::after {
  right: 0;
  width: 82px;
  height: 18px;
  clip-path: polygon(0 100%, 0 0, 82% 0, 100% 100%);
}

.hud-card__scan {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
}

.hud-card__scan::before {
  content: none;
  position: absolute;
  inset: -40% 0;
  background: linear-gradient(
    180deg,
    transparent 0%,
    transparent 38%,
    rgba(114, 216, 255, 0.12) 48%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(114, 216, 255, 0.12) 52%,
    transparent 62%,
    transparent 100%
  );
  animation: scanLine 8s linear infinite;
}

@keyframes cardReveal {
  from {
    opacity: 0;
    transform: translateY(28px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes scanLine {
  0% {
    transform: translateY(-45%);
  }
  100% {
    transform: translateY(45%);
  }
}

@media (max-width: 1080px) {
  .hud-card {
    padding: 34px 28px 30px;
  }

  .hud-card__frame--back,
  .hud-card__frame--mid,
  .hud-card__frame--front {
    display: none;
  }
}

@media (orientation: landscape) and (min-width: 1200px) {
  .hud-card {
    max-width: 1380px;
    padding: 48px clamp(38px, 3.4vw, 64px) 40px;
  }
}

@media (orientation: landscape) and (max-height: 820px) {
  .hud-card {
    padding: 28px 24px 24px;
    border-radius: 28px;
  }

  .hud-card::before {
    inset: 10px;
    border-radius: 22px;
  }

  .hud-card::after {
    inset: 18px;
    border-radius: 18px;
  }
}

@media (max-width: 768px) {
  .hud-card {
    padding: 24px 18px 22px;
    border-radius: 30px;
  }

  .hud-card::before {
    inset: 10px;
    border-radius: 24px;
  }

  .hud-card::after {
    inset: 18px;
    border-radius: 20px;
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .hud-card {
    padding: 16px 14px 14px;
    border-radius: 24px;
  }

  .hud-card::before {
    inset: 8px;
    border-radius: 18px;
  }

  .hud-card::after {
    inset: 14px;
    border-radius: 14px;
  }
}
</style>
